// Menu
import { ReactComponent as MenuEnquiry } from "../menu_icon/enquiry.svg";
import { ReactComponent as MenuLocation } from "../menu_icon/location.svg";
import { ReactComponent as MenuDashboard } from "../menu_icon/dashboard.svg";
import { ReactComponent as MenuRoster } from "../menu_icon/roster.svg";
import { ReactComponent as MenuLeave } from "../menu_icon/leave.svg";
import { ReactComponent as MenuAttendance } from "../menu_icon/attendance.svg";
import { ReactComponent as MenuSurvey } from "../menu_icon/survey.svg";
import { ReactComponent as MenuHR } from "../menu_icon/hr.svg";
import { ReactComponent as MenuCompany } from "../menu_icon/company.svg";
import { ReactComponent as MenuOpenIcon } from "../menu_icon/icon-menu.svg";
import { ReactComponent as MenuCloseIcon } from "../menu_icon/icon-menu.svg";
import { ReactComponent as MenuReviews } from "../menu_icon/icon-review.svg";
import { ReactComponent as MenuUsers } from "../menu_icon/users.svg";
import { ReactComponent as MenuAvail } from "../menu_icon/avail.svg";
import { ReactComponent as MenuTerminal } from "../menu_icon/icon-terminal.svg";
import { ReactComponent as MenuTeam } from "../menu_icon/team.svg";

import { ReactComponent as IconPin } from "../Images/icon-pin.svg";
import { ReactComponent as IconPinned } from "../Images/icon-pinned.svg";
import { ReactComponent as LogoIcon } from "../Images/logo-icon.svg";
import { ReactComponent as IconPlane } from "../Images/plane.png";
import { ReactComponent as IconUser } from "../Images/user.svg";
import { ReactComponent as IconEdit } from "../Images/pencil.svg";
import { ReactComponent as IconPound } from "../Images/pound.svg";
import { ReactComponent as IconBed } from "../Images/bed.svg";
import { ReactComponent as IconResidency } from "../Images/residency.svg";
import { ReactComponent as IconCalendar } from "../Images/calendar.svg";
import { ReactComponent as IconStatStat } from "../Images/staff-stat.svg";
import { ReactComponent as IconCalendarStat } from "../Images/calendar-stat.svg";
import { ReactComponent as IconGraphStat } from "../Images/graph-stat.svg";

import { ReactComponent as IconLink } from "../Icons/link.svg";
import { ReactComponent as IconPaidZero } from "../Icons/zero.svg";
import { ReactComponent as IconSick } from "../Icons/sick.svg";
import { ReactComponent as IconStatus } from "./status.svg";

import { ReactComponent as IconLock } from "./lock.svg";
import { ReactComponent as IconUnlock } from "./unlock.svg";

import { ReactComponent as IconAM } from "./am.svg";
import { ReactComponent as IconPM } from "./pm.svg";
import { ReactComponent as IconNight } from "./night.svg";
import { ReactComponent as IconFlexible } from "./flexible.svg";
import { ReactComponent as IconPasswordSet } from "./password-set.svg";
import { ReactComponent as IconDiscrepancy } from "../Icons/discrepancy.svg";
import { ReactComponent as IconBudget } from "../Icons/budget.svg";
import { ReactComponent as IconAutoClock } from "./autoclock.svg";

import { ReactComponent as IconFeedWork } from "./kudos/work.png";
import { ReactComponent as IconFeedBirthday } from "./kudos/birthday.png";
import { ReactComponent as IconFeedStar } from "./kudos/star.png";
import { ReactComponent as IconFeedThank } from "./kudos/thankyou.png";
import { ReactComponent as IconFeedCongra } from "./kudos/congratulations.png";
import { ReactComponent as KudosFeedBanner } from "./kudos/banner.png";

export default {
  MenuOpenIcon,
  MenuCloseIcon,
  MenuEnquiry,
  MenuLocation,
  IconStatus,
  MenuReviews,
  IconPin,
  IconPinned,
  LogoIcon,
  IconPlane,
  IconUser,
  IconEdit,
  IconPound,
  IconBed,
  IconResidency,
  IconCalendar,
  IconLink,
  MenuDashboard,
  MenuRoster,
  MenuLeave,
  MenuAttendance,
  MenuSurvey,
  MenuHR,
  MenuCompany,
  MenuUsers,
  IconStatStat,
  IconCalendarStat,
  IconGraphStat,
  IconLock,
  IconUnlock,
  IconAM,
  IconPM,
  IconNight,
  IconFlexible,
  IconPaidZero,
  IconSick,
  IconPasswordSet,
  IconDiscrepancy,
  IconBudget,
  MenuAvail,
  MenuTerminal,
  IconAutoClock,
  MenuTeam,

  // Kudos
  IconFeedWork,
  IconFeedBirthday,
  IconFeedStar,
  IconFeedThank,
  IconFeedCongra,
  KudosFeedBanner,
};
